<template>
  <vx-card title="Jumlah Layanan Berdasarkan Instansi">
    <global-wrapper
      :loading="loading"
      :loadingType="'avatar-three-line'"
      :loadingList="4"
      :scrollable="true"
      height="500px"
    >
      <Bar v-if="chartData"
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chart-id="'services-chart'"
        :width="width"
        :height="height"
      />
    </global-wrapper>
  </vx-card>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'

export default {
  name: 'ServiceByInstancy',
  components: { Bar },
  data() {
    return {
      loading: true,
      chartOptions: {
        responsive: true,
        indexAxis: 'x'
      },
      chartData: {},
      width: 400,
      height: 150
    }
  },
  mounted(){
    this.getChartData();
  },
  methods: {
    async getChartData(){
      const res = await this.$httpMpp.get('/app/statistic/services-by-agencies-data');
      let data = res.data.data;
      let colors = data.dataset.map(function (){
        return 'rgb(54, 162, 235)';
      });

      this.chartData = {
        labels: data.labels,
        datasets: [{
          label: `Jumlah Layanan`,
          data: data.dataset,
          backgroundColor: colors,
          borderColor: colors,
          borderWidth: 1,
          barThickness: 30
        }]
      }
      this.loading = false;
    }
  }
}
</script>